(() => {
  if (window.VelarioAvailability) return;
  const root = window.Shopify?.routes?.root || '/';
  async function json(url) {
    const response = await fetch(url, {cache:'no-store', headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('We could not confirm availability. Please try again before adding to your bag.');
    return response.json();
  }
  async function load() {
    const sections = await json(root + '?sections=velario-availability&_stock=' + Date.now());
    const doc = new DOMParser().parseFromString(sections['velario-availability'] || '', 'text/html');
    const data = doc.querySelector('[data-velario-availability]');
    if (!data) throw new Error('Availability is temporarily unavailable. Please refresh and try again.');
    return JSON.parse(data.textContent);
  }
  async function check(items, options = {}) {
    const [stock, cart] = await Promise.all([load(), json(root + 'cart.js')]);
    const requested = new Map();
    for (const item of items) {
      if (!Number.isInteger(Number(item.quantity)) || Number(item.quantity) < 1) throw new Error('Choose a valid quantity.');
      requested.set(String(item.id), (requested.get(String(item.id)) || 0) + Number(item.quantity));
    }
    for (const [id, quantity] of requested) {
      const variant = stock.variants[id];
      if (!variant) {
        if (options.bundle) throw new Error('A selected scent is no longer available. Please refresh your selection.');
        continue;
      }
      if (!variant.available) throw new Error(variant.name + ' is unavailable. Please choose another scent.');
      if (options.bundle && variant.preorder) throw new Error(variant.name + ' is a pre-order. Please order it separately from its product page.');
      const existing = cart.items.reduce((sum, line) => sum + (String(line.variant_id) === id ? line.quantity : 0), 0);
      if (variant.tracked && !(variant.preorder && variant.policy === 'continue') && existing + quantity > variant.quantity) {
        const left = Math.max(0, variant.quantity - existing);
        throw new Error(variant.name + ': ' + (left ? 'only ' + left + ' more available for your bag.' : 'no additional stock is available. Reduce the quantity or choose another scent.'));
      }
    }
    return stock;
  }
  window.VelarioAvailability = {load, check};
})();
